import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

function OrgBanner(props) {
  const { authentication, org } = props;

  useEffect(() => {

  }, []);
  let current_org = org?.list?.find(o => org.current_org_id == o.org_id) || {};
  let org_display = <h2>
    {current_org.display_name}
  </h2>
  if (current_org.banner_url) {
    org_display = <img src={current_org.banner_url} height="120" alt={current_org.display_name} />
  }

  return (
    <div className="org-banner">
        {org_display}
    </div>
  );
}

function mapStateToProps(state) {
  const { authentication, org } = state;
  return {
    org,
    authentication,
  };
}

const actionCreators = {

};

const connectedOrgBanner = connect(
  mapStateToProps,
  actionCreators
)(OrgBanner);
export { connectedOrgBanner as OrgBanner };
